// Clock
// Features:
// - Simple ticking wall clock with second, minute, and hour hands

import { useRef, useEffect } from 'react'
import * as THREE from 'three'

export default function Clock({ nodes, material }) {
    // Refs
    const secondRef = useRef()
    const minuteRef = useRef()
    const hourRef = useRef()

    // Drive the clock hands with fixed 1-second ticks
    useEffect(() => {
        const secondStep = -THREE.MathUtils.degToRad(6) // tick clockwise by 6° each second
        const minuteStep = secondStep / 60 // 1/60 of second
        const hourStep = minuteStep / 60 // 1/60 of minute

        const id = setInterval(() => {
            if (!secondRef.current || !minuteRef.current || !hourRef.current)
                return
            secondRef.current.rotation.x += secondStep
            minuteRef.current.rotation.x += minuteStep
            hourRef.current.rotation.x += hourStep
        }, 1000)

        return () => clearInterval(id)
    }, [])

    return (
        <group>
            <mesh
                ref={secondRef}
                geometry={nodes.clock_second.geometry}
                material={material}
                position={[-2.94, 2.779, 0.314]}
            />
            <mesh
                ref={minuteRef}
                geometry={nodes.clock_minute.geometry}
                material={material}
                position={[-2.94, 2.779, 0.314]}
                rotation={[-Math.PI / 4, 0, 0]}
            />
            <mesh
                ref={hourRef}
                geometry={nodes.clock_hour.geometry}
                material={material}
                position={[-2.94, 2.779, 0.314]}
                rotation={[Math.PI / 6, 0, 0]}
            />
        </group>
    )
}
